import React, { useState } from "react"
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { openPopup } from "../actions/popup"
import { openSnackbar } from "../actions/snackbar"
import { restoreChangePassword } from "../actions/user"

function UserRestorePasswordSuccess({ user, openSnackbar, recoverId, restoreChangePassword, openPopup }) {
  const [newPass, setNewPass] = useState("")
  const [tryPass, setTryPass] = useState("")
  if (user.status === "confirmed") {
    return (
      <Redirect to='/' />
    )
  } else {
    openPopup('Восстановить пароль',
      <form onSubmit={submitPassword} className='auth-passwordRestoreSuccess'>
        <input className="auth-input small" onChange={e => setNewPass(e.target.value)} autoComplete='off' type="password" placeholder="Новый пароль" />
        <input className="auth-input small" onChange={e => setTryPass(e.target.value)} autoComplete='off' style={{ marginTop: '12px' }} type="password" placeholder="Повторите пароль" />
        <button type='submit' className="auth-button mt-24" style={{ marginTop: '24px' }}>Изменить</button>
      </form>)
  }

  return (
    ''
  )

  function submitPassword(e) {
    e.preventDefault();
    if (newPass !== "" && tryPass !== "") {
      if (newPass === tryPass) {
        restoreChangePassword(recoverId, newPass)
      } else openSnackbar("Пароли не совпадают", "error")
    } else openSnackbar("Заполните все поля", "error")
  }
}

export default connect(null, { openSnackbar, restoreChangePassword, openPopup })(UserRestorePasswordSuccess)